import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [
  // 首页
  {
    path: '/index',
    component: () => import('@/pages/index'),
    meta: {
      title: '首页'
    },
    children: [
    // {
    //   path: '/customer_manage',
    //   component: () => import('@/pages/customer/customer_manage'),
    //   meta: {
    //     title: '客户管理-凤栖云服'
    //   }
    // },
    // {
    //   path: '/customer_details',
    //   component: () => import('@/pages/customer/customer_details'),
    //   meta: {
    //     title: '客户详情-凤栖云服'
    //   }
    // },
    {
      path: '/customer_manage',
      component: () => import('@/pages/customer_manage'),
      meta: {
        title: '客户管理-凤栖云服'
      }
    },
    {
      path: '/customer_details',
      component: () => import('@/pages/customer_details'),
      meta: {
        title: '客户详情-凤栖云服'
      }
    },
    {
      path: '/index_content',
      component: () => import('@/pages/index_content'),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/new_notice',
      component: () => import('@/pages/new_notice'),
      meta: {
        title: '最新公告-凤栖云服'
      }
    },
    {
      path: '/notice_details/:id',
      component: () => import('@/pages/notice_details'),
      meta: {
        title: '公告详情-凤栖云服'
      }
    },
    {
      path: '/article_detail/:id',
      component: () => import('@/pages/article_detail'),
      meta: {
        title: '文章详情-凤栖云服'
      }
    },
    {
      path: '/finance/policy_statistics',
      component: () => import('@/pages/finance/policy_statistics'),
      meta: {
        title: '保单统计-凤栖云服'
      }
    },
    {
      path: '/finance_m',
      component: () => import('@/pages/finance/finance_m'),
      meta: {
        title: '财务管理-凤栖云服'
      }
    },
    {
      path: '/finance/withdrawal',
      component: () => import('@/pages/finance/withdrawal'),
      meta: {
        title: '二级机构提现-凤栖云服'
      }
    },
    {
      path: '/finance/settlement',
      component: () => import('@/pages/finance/settlement'),
      meta: {
        title: '二级机构结算-凤栖云服'
      }
    },
    {
      path: '/finance/productContinue',
      component: () => import('@/pages/finance/productContinue'),
      meta: {
        title: '产品续期政策-凤栖云服'
      }
    },
    {
      path: '/finance/renewalRatio',
      component: () => import('@/pages/finance/renewalRatio'),
      meta: {
        title: '续期继续率统计-凤栖云服'
      }
    },
    {
      path: '/finance/serveCostRecord',
      component: () => import('@/pages/finance/serveCostRecord'),
      meta: {
        title: '服务费记录-凤栖云服'
      }
    },
    // {
    //   path: '/myproduct',
    //   component: () => import('@/pages/product_m/myproduct'),
    //   meta: {
    //     title: '我的商品-凤栖云服'
    //   }
    // },
    {
      path: '/productlibrary',
      component: () => import('@/pages/product_m/productlibrary/productlibrary'),
      meta: {
        title: '商品库-凤栖云服'
      }
    },
    {
      path: '/productdata/:id',
      component: () => import('@/pages/product_m/productdata'),
      meta: {
        title: '商品资料-凤栖云服'
      }
    },
    {
      path: '/maininfo',
      component: () => import('@/pages/person/maininfo'),
      meta: {
        title: '个人中心-凤栖云服'
      }
    },
    {
      name:'authenticationInformation',
      path: '/authenticationInformation',
      component: () => import('@/pages/person/authenticationInformation'),
      meta: {
        title: '认证信息-凤栖云服'
      }
    },
    {
      path: '/myweb',
      component: () => import('@/pages/myweb/myweb'),
      meta: {
        title: '我的网站-凤栖云服'
      }
    },
    // {
    //   path: '/myphone',
    //   component: () => import('@/pages/myweb/myphone'),
    //   meta: {
    //     title: '我的网站-凤栖云服'
    //   }
    // },
    {
      path: '/myphone',
      component: () => import('@/pages/myweb/onlineStore'),
      meta: {
        title: '我的网站-凤栖云服'
      }
    },
    {
      path: '/editDefTempalte',
      component: () => import('@/pages/myweb/component/editDefTempalte'),
      meta: {
        title: '系统默认模板-凤栖云服'
      }
    },
    {
      path: '/addWebSiteTempalte',
      component: () => import('@/pages/myweb/component/addTempalte'),
      meta: {
        title: '新增模板-凤栖云服',
      },
    },

    {
      path: '/myxcxset',
      component: () => import('@/pages/myweb/myxcxset'),
      meta: {
        title: '我的网站-凤栖云服'
      }
    },
    {
      path: '/phoneset',
      component: () => import('@/pages/myweb/phoneset'),
      meta: {
        title: '我的网站-凤栖云服'
      }
    },
    {
      path: '/webset',
      component: () => import('@/pages/myweb/webset'),
      meta: {
        title: '网站设置-凤栖云服'
      }
    },
    {
      path: '/mechanism',
      component: () => import('@/pages/mechanism_m/mechanism'),
      meta: {
        title: '机构管理-凤栖云服'
      }
    },
    {
      path: '/achievement',
      component: () => import('@/pages/finance/achievement'),
      meta: {
        title: '业绩统计-凤栖云服'
      }
    },
    {
      path: '/statistics',
      component: () => import('@/pages/finance/statistics'),
      meta: {
        title: '机构业绩-凤栖云服'
      }
    },
    {
      path: '/oneStatistics',
      component: () => import('@/pages/finance/oneStatistics'),
      meta: {
        title: '我的业绩-凤栖云服'
      }
    },
    {
      path: '/waitSettlement',
      component: () => import('@/pages/finance/waitSettlement'),
      meta: {
        title: '待生效明细-凤栖云服'
      }
    },
    {
      path: '/settlementDetail',
      component: () => import('@/pages/finance/settlementDetail'),
      meta: {
        title: '结算明细-凤栖云服'
      }
    },
    {
      path: '/apiConfigure',
      component: () => import('@/pages/api/apiConfigure'),
      meta: {
        title: '接口配置-凤栖云服'
      }
    },
    {
      path: '/api/callback',
      component: () => import('@/pages/api/callback'),
      meta: {
        title: '回调记录-凤栖云服'
      }
    },
    {
      path: '/api/document',
      component: () => import('@/pages/api/document'),
      meta: {
        title: '在线文档-凤栖云服'
      }
    },
    {
      path: '/api/documentDetail',
      component: () => import('@/pages/api/documentDetail'),
      meta: {
        title: '在线文档-凤栖云服'
      }
    },
    {
      path: '/childAchiev',
      component: () => import('@/pages/orgManage/childRank/childAchiev'),
      meta: {
        title: '员工详情-凤栖云服'
      }
    },
    {
      path: '/childRank',
      component: () => import('@/pages/orgManage/childRank/childRank'),
      meta: {
        title: '业绩排行-凤栖云服'
      }
    },
    {
      path: '/childTemplate',
      component: () => import('@/pages/orgManage/productTemplate/childTemplate'),
      meta: {
        title: '产品模板-凤栖云服'
      }
    },
    {
      path: '/adviser',
      component: () => import('@/pages/marketing/adviser'),
      meta: {
        title: '预约客户-凤栖云服'
      }
    },
    {
      path: '/xcxSet',
      component: () => import('@/pages/marketing/xcxSet'),
      meta: {
        title: '预核保配置-凤栖云服'
      }
    },
    {
      path: '/order_wait',
      component: () => import('@/pages/order/order_wait'),
      meta: {
        title: '未完成订单跟踪-凤栖云服'
      }
    },
    {
      path: '/order_detail',
      component: () => import('@/pages/order/order_detail'),
      meta: {
        title: '订单详情-凤栖云服'
      }
    },
    //empower
    {
      path: '/empower',
      component: () => import('@/pages/marketing/empower'),
      meta: {
        title: '授权设置-凤栖云服'
      }
    },
    {
      path: '/procedure',
      component: () => import('@/pages/marketing/procedure'),
      meta: {
        title: '跟进流程-凤栖云服'
      }
    },
    {
      path: '/preOrder',
      component: () => import('@/pages/marketing/preOrder'),
      meta: {
        title: '预约订单-凤栖云服',
        keepAlive:true,
      }
    },
    {
      path: '/marketing/prePolicy',
      component: () => import('@/pages/marketing/prePolicy'),
      meta: {
        title: '预约投保单-凤栖云服',
        keepAlive:true,
      }
    },
    {
      path: '/marketing/customer',
      component: () => import('@/pages/marketing/customer'),
      meta: {
        title: '资源管理-凤栖云服'
      }
    },
    {
      path: '/marketing/policyList',
      component: () => import('@/pages/marketing/policyList'),
      meta: {
        title: '成交保单-凤栖云服'
      }
    },
    {
      path: '/demo',
      component: () => import('@/pages/demo'),
      meta: {
        title: '预约订单-凤栖云服'
      }
    },
    {
      path: '/college',
      component: () => import('@/pages/product_m/college'),
      meta: {
        title: '凤栖云学院-凤栖云服'
      }
    },
    {
      path: '/searchPage',
      component: () => import('@/pages/product_m/components/searchPage'),
      meta: {
        title: '凤栖云学院搜索页-凤栖云服'
      }
    },
    {
      path: '/plan',
      component: () => import('@/pages/marketing/plan'),
      meta: {
        title: '计划书-凤栖云服'
      }
    },
    {
      path: '/marketing/activity',
      component: () => import('@/pages/marketing/activity'),
      meta: {
        keepAlive: true,
        title: '活动管理-凤栖云服'
      }
    },
    {
      path: '/marketing/activityDetail',
      component: () => import('@/pages/marketing/activityDetail'),
      meta: {
        title: '活动详情-凤栖云服'
      }
    },
    {
      path: '/cmzOrder',
      component: () => import('@/pages/Customized/cmzOrder'),
      meta: {
        title: '定制付费订单',
        keepAlive:true,
      }
    },
    {
      path: '/cmzDetail',
      component: () => import('@/pages/Customized/cmzDetail'),
      meta: {
        title: '定制付费订单详情'
      }
    },
    {
      path: '/cmzExplain',
      component: () => import('@/pages/Customized/cmzExplain'),
      meta: {
        title: '定制付费说明'
      }
    },

    {
      path: '/weChat/index',
      component: () => import('@/pages/weChat/index'),
      meta: {
        title: '公众号管理-凤栖云服'
      }
    },
    {
      path: '/weChat/editMenu',
      component: () => import('@/pages/weChat/editMenu'),
      meta: {
        title: '编辑菜单-凤栖云服'
      }
    },
    {
      path: '/weChat/autoReply',
      component: () => import('@/pages/weChat/autoReply'),
      meta: {
        title: '自动回复-凤栖云服'
      }
    },
    {
      path: '/weChat/kefu',
      component: () => import('@/pages/weChat/kefu'),
      meta: {
        title: '客服管理-凤栖云服'
      }
    },
    {
      path: '/weChat/marketing',
      component: () => import('@/pages/weChat/marketing'),
      meta: {
        title: '主动营销-凤栖云服'
      }
    },
    {
      path: '/weChat/material',
      component: () => import('@/pages/weChat/material'),
      meta: {
        title: '素材管理-凤栖云服'
      }
    },
    {
      path: '/weChat/channelCode',
      component: () => import('@/pages/weChat/channelCode'),
      meta: {
        title: '渠道二维码-凤栖云服'
      }
    },
    {
      path: '/weChat/follow',
      component: () => import('@/pages/weChat/follow'),
      meta: {
        title: '关注数据-凤栖云服'
      }
    },
    {
      path: '/setting/app',
      component: () => import('@/pages/setting/app'),
      meta: {
        title: 'APP设置-凤栖云服'
      }
    },
    {
      path: '/setting/kefu',
      component: () => import('@/pages/setting/kefu'),
      meta: {
        title: '客服设置-凤栖云服'
      }
    },
    {
      path: '/setting/auth',
      component: () => import('@/pages/setting/auth'),
      meta: {
        title: '授权设置-凤栖云服'
      }
    },
    {
      path: '/rateModule',
      component: () => import('@/pages/mechanism_m/rateModule'),
      meta: {
        title: '费率模板-凤栖云服'
      }
    },
    {
      path: '/rateDetails',
      component: () => import('@/pages/mechanism_m/rateDetails'),
      meta: {
        title: '费率模板-凤栖云服'
      }
    },
    {
      path: '/order_tbd',
      component: () => import('@/pages/order/order_tbd'),
      meta: {
        keepAlive: true,
        title: '投保单-凤栖云服'
      }
    },
    {
      name: 'order_tbd_detail',
      path: '/order_tbd_detail',
      component: () => import('@/pages/order/order_tbd_detail'),
      meta: {
        title: '投保单订单详情-凤栖云服'
      }
    },
    {
      name:'order_double_recording',
      path: '/order_double_recording',      
      component: () => import('@/pages/order/order_double_recording'),
      meta: {
        title: '双录单-凤栖云服',
        keepAlive:true,
      }
    },
    {
      name: 'order_xfd_detail',
      path: '/order_xfd_detail',
      component: () => import('@/pages/order/order_xfd_detail'),
      meta: {
        title: '续保单订单详情-凤栖云服'
      }
    },
    {
      path: '/order_rhd',
      component: () => import('@/pages/order/order_rhd'),
      meta: {
        keepAlive: true,
        title: '人核单-凤栖云服'
      }
    },
    {
      path: '/order_xbd',
      component: () => import('@/pages/order/order_xbd'),
      meta: {
        keepAlive: true,
        title: '续保单-凤栖云服'
      }
    },
    {
      path: '/order_lrd',
      component: () => import('@/pages/order/order_lrd'),
      meta: {
        keepAlive: true,
        title: '代投单-凤栖云服'
      }
    },
    {
      path: '/order_xfd',
      component: () => import('@/pages/order/order_xfd'),
      meta: {
        keepAlive: true,
        title: '续费单-凤栖云服'
      }
    },
    {
      path: '/product/customEntry',
      component: () => import('@/pages/product_m/customEntry'),
      meta: {
        title: '产品工坊-凤栖云服'
      }
    },
    {
      path: '/product/customOne',
      component: () => import('@/pages/product_m/customOne'),
      meta: {
        title: '产品工坊-凤栖云服'
      }
    },
    {
      path: '/product/customEdit',
      component: () => import('@/pages/product_m/customEdit'),
      meta: {
        title: '编辑模板-凤栖云服'
      }
    },
    {
      path: '/cloudCollege',
      component: () => import('@/pages/product_m/cloudCollege'),
      meta: {
        keepAlive:true,
        title: '凤栖云学院-凤栖云服'
      },
    },
    {
      path: '/cloudCollege/seriesVideo',
      component: () => import('@/pages/product_m/seriesVideo'),
      meta: {
        keepAlive:true,
        title: '系列视频-凤栖云服'
      },
    },
    {
      path: '/articleDetail',
      component: () => import('@/pages/product_m/components/articleDetail'),
      meta: {
        title: '云学院文章详情-凤栖云服'
      }
    },
    {
      path: '/reVisitManage',
      component: () => import('@/pages/order/reVisitManage'),
      meta: {
        title: '回执回访管理-凤栖云服'
      }
    },
    {
      path: '/orgManage',
      component: () => import('@/pages/orgManage/orgManage/index'),
      meta: {
        title: '组织管理-凤栖云服',
        keepAlive:true,
      },
    },
    {
      path: '/orgManage/feeTemplate',
      component: () => import('@/pages/orgManage/feeTemplate/index'),
      name:"orgManage.feeTemplate",
      meta: {
        title: '服务费模板-凤栖云服',
        keepAlive:true,
      },
    },
    {
      path: '/orgManage/feeTemplateDetail',
      component: () => import('@/pages/orgManage/feeTemplate/feeTemplateDetail'),
      name:"orgManage.feeTemplateDetail",
      meta: {
        title: '模板详情-凤栖云服',
      },
    },
    {
      path: '/orgManage/roleList',
      component: () => import('@/pages/orgManage/roleList/roleList'),
      name:"orgManage.roleList",
      meta: {
        title: '角色权限-凤栖云服',
      },
    },
    {
      path: '/orgManage/account',
      component: () => import('@/pages/orgManage/account/account'),
      name:"orgManage.account",
      meta: {
        title: '账号设置-凤栖云服',
      },
    },
    {
      path: '/insureOrder',
      component: () => import('@/pages/groupInsurance/insureOrder'),
      meta: {
        title: '投保订单'
      }
    },
    {
      path: '/peservationOrder',
      component: () => import('@/pages/groupInsurance/peservationOrder'),
      meta: {
        title: '保全订单'
      }
    },
    {
      path: '/policy',
      component: () => import('@/pages/groupInsurance/policy'),
      meta: {
        title: '团财险保单'
      }
    },
    {
      path: '/policyDetail',
      component: () => import('@/pages/groupInsurance/policyDetail'),
      meta: {
        title: '团财险保单详情'
      }
    },
    {
      path: '/invoiceList',
      component: () => import('@/pages/groupInsurance/invoiceList'),
      meta: {
        title: '申请开票'
      }
    },
    {
      path: '/groupSettlement',
      component: () => import('@/pages/groupInsurance/groupSettlement'),
      meta: {
        title: '团险结算'
      }
    },
    {
      path: '/visitor/index',
      component: () => import('@/pages/visitorManage/index'),
      meta: {
        title: '访客管理-凤栖云服',
        keepAlive: true
      }
    },
    {
      path: '/visitor/event',
      component: () => import('@/pages/visitorManage/visitorEvent'),
      meta: {
        title: '产品访客事件-凤栖云服'
      }
    },
    {
      path: '/visitor/detail',
      component: () => import('@/pages/visitorManage/detail'),
      meta: {
        title: '访客管理详情-凤栖云服'
      }
    },
    ]
  },
  {
    path: '/help',
    component: () => import('@/pages/help/main'),
    meta: {
      title: '帮助中心-凤栖云服'
    },
    children: [
      {
        path: '/help/index',
        component: () => import('@/pages/help/index'),
        meta: {
          title: '帮助中心-凤栖云服'
        }
      },
      {
        path: '/help/detail',
        component: () => import('@/pages/help/detail'),
        meta: {
          title: '帮助中心-凤栖云服'
        }
      },
      {
        path: '/help/search',
        component: () => import('@/pages/help/search'),
        meta: {
          title: '帮助中心-凤栖云服'
        }
      }
    ]
  },
  {
    path: '/costAgreement',
    component: () => import('@/pages/costAgreement'),
    meta: {
      title: '费用结算服务协议-凤栖云服'
    }
  },
  {
    path: '/',
    component: () => import('@/pages/login'),
    meta: {
      title: '登录-凤栖云服'
    }
  },
  {
    path: '/login',
    component: () => import('@/pages/login'),
    meta: {
      title: '登录-凤栖云服'
    }
  },
  {
    path: '/tokenLogin',
    component: () => import('@/pages/tokenLogin'),
    meta: {
      title: '加载中-凤栖云服'
    }
  },
  {
    path: '/insteadTbLogin',
    component: () => import('@/pages/insteadTbLogin'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/register',
    component: () => import('@/pages/register'),
    meta: {
      title: '注册-凤栖云服'
    }
  },
  {
    path: '/forget',
    component: () => import('@/pages/forget'),
    meta: {
      title: '忘记密码-凤栖云服'
    }
  },
]

const router = new VueRouter({
  // mode: 'history',
  routes
})
//避免跳转一样的url NavigationDuplicated: Avoided redundant navigation to current 报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
// 处理发版导致的缓存报错
router.onError(error => {
  const pattern = /Loading chunk (\S*)+ failed/g
  const isError = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  console.log("router.onError",isError,error)
  if (isError) {
    // location.reload();
    // router.replace(targetPath)
    location.replace(`/fxyf/index.html?t=${new Date().getTime()}#${targetPath}`)
  }
});
export default router